import { render, staticRenderFns } from "./TemplateEditorAddPlaceholder.vue?vue&type=template&id=3e3f5c79&scoped=true"
import script from "./TemplateEditorAddPlaceholder.vue?vue&type=script&lang=ts"
export * from "./TemplateEditorAddPlaceholder.vue?vue&type=script&lang=ts"
import style0 from "./TemplateEditorAddPlaceholder.vue?vue&type=style&index=0&id=3e3f5c79&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e3f5c79",
  null
  
)

export default component.exports